<template>
  <div class="foot">
    <div style="width: 1200px; height: 100%; padding: 50px 0; margin: 0 auto">
      <div class="foot-wrap">
        <div class="foot-l">
          <div class="friend">
            <p
              style="
                height: 17px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #ffffff;
                margin-bottom:13px
              "
            >
              友情链接：
            </p>
            <span
              ><a
                target="_blank"
                href="http://rst.nmg.gov.cn/nmrsw/"
                title="内蒙古人民政府"
                >内蒙古人民政府</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://rst.xinjiang.gov.cn/"
                title="新疆人社厅"
                >新疆人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="https://kjt.nmg.gov.cn/"
                title="内蒙古科技厅"
                >内蒙古科技厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://hrss.hlj.gov.cn/hrss/login/entry.ks"
                title="黑龙江人社厅"
                >黑龙江人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://www.hljkjt.gov.cn/"
                title="黑龙江省科技厅"
                >黑龙江省科技厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://hrss.ah.gov.cn/"
                title="安徽省人社厅"
                >安徽省人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://kjt.ah.gov.cn/"
                title="安徽省科技厅"
                >安徽省科技厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="https://rst.hebei.gov.cn/index.html"
                title="河北省人社厅"
                >河北省人社厅</a
              ></span
            >
            <span style=""
              ><a
                target="_blank"
                href="https://rsj.qhd.gov.cn/"
                title="秦皇岛市人社厅"
                >秦皇岛市人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://rst.shanxi.gov.cn/"
                title="山西省人社厅"
                >山西省人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://hrss.gd.gov.cn/"
                title="广东省人社厅"
                >广东省人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://rsj.gz.gov.cn/"
                title="广州市人社局"
                >广州市人社局</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://rlsbj.cq.gov.cn/"
                title="重庆市人社局"
                >重庆市人社局</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://rst.gansu.gov.cn/"
                title="甘肃省人社厅"
                >甘肃省人社厅</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                href="http://rsj.lanzhou.gov.cn/"
                title="兰州市人社局"
                >兰州市人社局</a
              ></span
            >
            <span style="margin-left: 18px"
              ><a
                target="_blank"
                @click.prevent="
                  handlePreView(
                    'https://dyqc.oss-accelerate.aliyuncs.com/wangchuang/qc/prod/img/product/bccca63e30534b478994fd5257b92ed9.jpg'
                  )
                "
                >电子营业执照</a
              ></span
            >
          </div>
          <div class="firm">
            <span style=""
              ><a target="_blank" href="http://www.qcwlcloud.com/"
                >主办单位:启创未来（北京）科技有限公司</a
              ></span
            >
            <span style="margin-left: 50px"
              ><a target="_blank" href="http://www.qcwlcloud.com/"
                >运营商:启创未来（北京）科技有限公司</a
              ></span
            >
          </div>
        </div>

        <div class="foot-r">
          <div class="foot-r-i" style="cursor: pointer" @click="toAboutUs">
            关于我们
          </div>
          <div class="foot-r-i" style="margin-top: 22px">
            <span>联系邮箱&nbsp;:&nbsp;</span>
            <span style="margin-left: 1px">yunpingtai@qcwlcloud.com</span>
          </div>
          <div class="foot-r-i" style="opacity: 1; margin-top: 20px">
            <span style="opacity: 0.6">联系电话&nbsp;:&nbsp;</span>
            <span
              style="
                margin-left: 1px;
                font-size: 14px;
                color: rgba(255, 255, 255, 1);
                opacity: 0.6
              "
              >400-1858-365</span
            >
          </div>
          <div class="foot-r-i" style="opacity: 1; margin-top: 20px">
            <span style="opacity: 0.6">举报电话&nbsp;:&nbsp;</span>
            <span
              style="
                margin-left: 1px;
                font-size: 14px;
                color: rgba(255, 255, 255, 1);opacity: 0.6
              "
              >400-1858-365</span
            >
          </div>
        </div>
      </div>
      <div class="foot-line"></div>
      <div class="foot-btm-wrap">
        <div class="friend">
          <span style=""
            ><a
              target="_blank"
              href="https://www.12377.cn/"
              title="北京市人社局"
              >网上有害信息举报专区</a
            ></span
          >
          <span class="foot-btm-line"></span>
          <span style=""
            ><a
              target="_blank"
              @click.prevent="
                handlePreView(
                  'https://dyqc.oss-accelerate.aliyuncs.com/wangchuang/qc/prod/img/product/675e39731c294cdbb4ed9992c5a6f076.jpeg'
                )
              "
              >人力资源服务许可证</a
            ></span
          ><span class="foot-btm-line"></span><span style=""
            ><a
              target="_blank"
              @click.prevent="
                handlePreView(
                  'https://dyqc.oss-cn-hangzhou.aliyuncs.com/cloud/base/img/qperatinglicense.jpg'
                )
              "
              >增值电信业务经营许可证</a
            ></span
          ><span class="foot-btm-line"></span>
          <span style=""
            ><a
              target="_blank"
              @click.prevent="
                handlePreView(
                  'https://dyqc.oss-cn-hangzhou.aliyuncs.com/cloud/file/%E4%BA%BA%E5%8A%9B%E8%B5%84%E6%BA%90%E6%9C%8D%E5%8A%A1%E6%8A%95%E8%AF%89%E5%A4%84%E7%90%86%E5%88%B6%E5%BA%A6.pdf'
                )
              "
              >投诉处理制度</a
            ></span
          ><span class="foot-btm-line"></span>
          <span style=""
            ><a
              target="_blank"
              @click.prevent="
                handlePreView(
                  'https://dyqc.oss-cn-hangzhou.aliyuncs.com/jycyffw/file/%E5%B0%B1%E4%B8%9A%E5%88%9B%E4%B8%9A%E6%9C%8D%E5%8A%A1%E7%BD%91%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf'
                )
              "
              >用户服务协议</a
            ></span
          ><span class="foot-btm-line"></span>
          <span style=""
            ><a
              target="_blank"
              @click.prevent="
                handlePreView(
                  'https://dyqc.oss-cn-hangzhou.aliyuncs.com/cloud/file/%E5%B0%B1%E4%B8%9A%E5%88%9B%E4%B8%9A%E6%9C%8D%E5%8A%A1%E7%BD%91%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E4%BF%9D%E6%8A%A4%E6%94%BF%E7%AD%96.pdf'
                )
              "
              >个人信息保护政策</a
            ></span
          >
        </div>
        <div class="infor">
          <span>Copyright © 启创未来（北京）科技有限公司</span>
          <span style="margin-left: 18px"
            ><a target="_blank" href="https://beian.miit.gov.cn/"
              >备案号：京ICP备16052847号-3</a
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "foot",
  methods: {
    toAboutUs() {
      sessionStorage.setItem("tabIndex", 0);
      this.$router.push("/aboutus");
    },
    handlePreView(s) {
      window.open(s, "_blank");
      return false;
    },
  },
};
</script>

<style scoped lang="less">
@import "../../assets/public.less";
.foot-wrap {
  display: flex;
  justify-content: space-between;
}
.foot-line {
  margin-top: 15px;
  margin-bottom: 24px;
  width: 1200px;
  height: 1px;
  background: #ffffff;
  opacity: 0.35;
}
.foot-btm-line {
  display: inline-block;
  vertical-align: middle;
  width: 1px;
  height: 15px;
  background: #FFFFFF;
  opacity: 0.6;
  margin: 0 10px;
}
.foot-btm-wrap {
  .friend {
    span {
      opacity: 0.6;
    }
  }
  .infor {
      margin-top: 13px;
      height: 12px;
      line-height: 12px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      span {
        opacity: 0.6;
        a {
          color: white;
        }
      }
      span:hover {
        opacity: 1;
      }
      span:first-of-type:hover {
        opacity: 0.6;
      }
    }
}
.friend {
  width: 100%;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  span {
    display: inline-block;
    opacity: 0.6;
    a {
      color: white;
    }
    line-height: 28px;
  }
  span:hover {
    opacity: 1;
  }
  span:first-of-type:hover {
    opacity: 0.6;
  }
}
.foot {
  width: 100%;
  background: #232323;
  .foot-l {
    width: 840px;
    .firm {
      width: 100%;
      line-height: 48px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      // opacity:0.6;
      span {
        opacity: 0.6;
        a {
          color: white;
        }
        
      }
      span:hover {
        opacity: 1;
      }
    }
    .friend {
      width: 100%;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      span {
        display: inline-block;
        opacity: 0.6;
        a {
          color: white;
        }
        line-height: 24px;
      }
      span:hover {
        opacity: 1;
      }
      span:first-of-type:hover {
        opacity: 0.6;
      }
    }
    
  }
  .foot-r {
    .foot-r-i {
      height: 12px;
      line-height: 12px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      opacity: 0.6;
    }
    .foot-r-i:first-of-type:hover {
      opacity: 1;
    }
  }
}
</style>